export default __webpack_public_path__ + "static/media/img-chip.b6408d47.png";